import { NormalizedSchema } from 'normalizr';

export const createSuccesAction = <E, R>(
  normalizedResults: NormalizedSchema<E, R>,
): any => ({
  type: 'CREATE_SUCCESS',
  payload: normalizedResults.result,
  meta: {
    entities: normalizedResults.entities,
  },
});

export const getOneSuccessAction = <E, R>(
  normalizedResults: NormalizedSchema<E, R>,
): any => ({
  type: 'GET_ONE_SUCCESS',
  payload: normalizedResults.result,
  meta: {
    entities: normalizedResults.entities,
  },
});

export const getListSuccessAction = <E, R>(
  normalizedResults: NormalizedSchema<E, R>,
): any => ({
  type: 'GET_LIST_SUCCESS',
  payload: normalizedResults.result,
  meta: {
    entities: normalizedResults.entities,
  },
});

export const updateSuccessAction = <E, R>(
  normalizedResults: NormalizedSchema<E, R>,
): any => ({
  type: 'UPDATE_SUCCESS',
  payload: normalizedResults.result,
  meta: {
    entities: normalizedResults.entities,
  },
});

export const replaceSuccessAction = <E, R>(
  normalizedResults: NormalizedSchema<E, R>,
): any => ({
  type: 'REPLACE_SUCCESS',
  payload: normalizedResults.result,
  meta: {
    entities: normalizedResults.entities,
  },
});

export const deleteOneSuccessAction = <E, R>(
  normalizedResults: NormalizedSchema<E, R>,
  options: { id?: string },
): any => ({
  type: 'DELETE_ONE_SUCCESS',
  payload: { id: options.id },
  meta: {
    entities: normalizedResults.entities,
  },
});

export const optimisticUpdate = (
  name: string,
  id: string,
  entity: any,
): any => ({
  type: 'OPTIMISTIC_UPDATE',
  meta: {
    entities: {
      [name]: {
        [id]: entity,
      },
    },
  },
});
export const optimisticDiscard = (
  name: string,
  id: string,
  entity: any,
): any => ({
  type: 'OPTIMISTIC_DISCARD',
  meta: {
    entities: {
      [name]: {
        [id]: entity,
      },
    },
  },
});
